<template>
    <div>
        <ul>
            <li class="step_panel" v-for="(item,index) in stepList">
                <div class="step_panel_main">
                    <div v-if="item.stepNumber < step" class="success">
                        <img class="success_icon" src="../../assets/success_icon.png" alt="">
                    </div>
                    <div v-if="item.stepNumber >= step" v-bind:class="{active:item.stepNumber == step}"  class="circle">
                        <span>{{item.stepNumber}}</span>
                    </div>
                    <div class="line" v-if="index != stepList.length -1"></div>
                </div>
                <p class="step_text">
                    <span>{{item.stepName}}</span>
                </p>
            </li>
            <!--<li class="step_panel">
                <div class="step_panel_main">
                    <div class="active circle">
                        <span>1</span>
                    </div>
                    <div class="line"></div>
                </div>
                <p class="step_text">
                    <span>季度POS上传</span>
                    <span>&补货目标天数设置</span>
                </p>
            </li>
            <li class="step_panel">
                <div class="step_panel_main">
                    <div class="circle">
                        <span>2</span>
                    </div>
                    <div class="line"></div>
                </div>
                <p class="step_text">门店运营参数配置</p>
            </li>
            <li class="step_panel">
                <div class="step_panel_main"> 
                    <div class="circle">
                        <span>3</span>
                    </div>
                    <div class="line"></div>
                </div>
                <p class="step_text">周补货频次设置</p>
            </li>
            <li class="step_panel">
                <div class="step_panel_main">
                    <div class="circle">
                        <span>4</span>
                    </div>
                    <div class="line"></div>
                </div>
                <p class="step_text">模型计算</p>
            </li>
            <li class="step_panel">
                <div class="step_panel_main">
                    <div class="circle">
                        <span>5</span>
                    </div>
                </div>
                <p class="step_text">结果展示</p>
            </li>-->
        </ul>
    </div>
</template>
<script>
export default {
  name: "PageNavigation",
  props:['step'],
  data() {
    return {
        stepList:[
            {
                stepNumber:1,
                stepName:'季度POS&目标天数'
            },
            {
                stepNumber:2,
                stepName:'门店运营参数配置'
            },
            {
                stepNumber:3,
                stepName:'周补货频次设置'
            },
            {
                stepNumber:4,
                stepName:'模型计算'
            },
            {
                stepNumber:5,
                stepName:'结果展示'
            }
        ]
    };
  }
};
</script>
<style scoped>
ul {
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.step_panel {
  float: left;
  list-style: none;
  overflow: hidden;
}
.step_panel .circle,.step_panel .success{
  display: inline-block;
  width: 0.15rem;
  height: 0.15rem;
  color: #fff;
  background-color: #6e6e6e;
  border-radius: 50%;
  margin-top: 0.15rem;
  float: left;

}
.step_panel .success{
    background-color: #f7f7f7;
}
.step_panel .active {
  width: 0.35rem;
  height: 0.35rem;
  background: #fff;
  border: 0.052rem solid #fa5400;
  border-radius: 50%;
  line-height: 0.35rem;
  margin-top: 0.05rem;
}
.step_panel .active::before {
  display: block;
  content: "";
  width: 0.21rem;
  height: 0.21rem;
  border-radius: 50%;
  background-color: #fa5400;
  position: relative;
  top: 0.02rem;
  left: 0.02rem;
}
.active span {
  position: relative;
  top: -0.25rem;
}
.line {
  width: 1.37rem;
  height: 0.03rem;
  background-color: #dfdfdf;
  margin: 0.11rem;
  vertical-align: top;
  margin-top: 17px;
  display: inline-block;
  float: left;
}
.step_panel_main {
  height: 0.47rem;
}
.step_text {
  display: block;
  text-align: left;
  font-size: 0.15rem;
  max-width: 1.4rem;
}
.step_text span {
  display: block;
  font-weight: bold;
}
.success_icon{
    width:0.22rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PageNavigation.vue